import { isUndefined } from 'lodash'

export const getFormData = (dirtyRowData: Record<string, unknown>) => {
  const formData = new FormData()
  Object.entries(dirtyRowData).forEach(([key, value]) => {
    if (!isUndefined(value)) {
      formData.append(key, value as string | File)
    }
  })

  return formData
}
